'use strict';
var ResourcesByHealthConditionController = /** @class */ (function () {
    /*@ngInject*/
    function ResourcesByHealthConditionController($scope, ResourcesByHealthConditionsService, $sce, $stateParams, EducationSubNavService) {
        this.headerContent = "We are proud to offer our customers complimentary access to the Aisle 7 database. Explore below for information on health conditions as well as supplement and lifestyle recommendations.";
        $scope.$ctrl.value.selectedpageindex = 0;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
        this.ResourcesByHealthConditionsService = ResourcesByHealthConditionsService;
        $scope.frameUrl = $sce.trustAsResourceUrl('/api/education/clinical-resources-subpage?page=heath-condition');
    }
    return ResourcesByHealthConditionController;
}());
export default ResourcesByHealthConditionController;
//# sourceMappingURL=resources-by-health-condition.controller.js.map